module.exports = __webpack_public_path__ + "static/media/lurk.21a91a73.jpg";